import request from "@/services/request";
import baseUrl from "@/services/baseUrl";

// this is for globally used APIs only
const feeURL = baseUrl.main + "/fapi/fee/";

export default {
    calculate: (param = {}) => request.post(feeURL + "calculate", param),
    calculateTransfer: (param = {}) => request.post(feeURL + "calculate-transfer-fee", param),
    getTypes: (param = {}) => request.get(feeURL + "account-types"),
    getTransactionTypes: (param = {}) => request.get(feeURL + "transfer-types"),
    getCurrencies: (param = {}) => request.get(feeURL + "currencies"),
}

